<template>
    <div class="card-area" :style="areaStyle" ref="$cardArea">
        <template v-if="showCardList">
            <template v-for="(item, index) in cardList">
                <Card v-if="item.name === 'card'" :key="index" :index="index" :info="item" @emitEvent="receiveEvent" />
                <!-- 卡片组件 -->
                <NewAudio v-if="item.name === 'audio'" :key="index" :index="index" :info="item"
                    :activityStatus="$activityStatus" :activityType="$$activityType" :activityId="$$activityId" />
            </template>
        </template>

        <template v-if="showViewCard">
            <!-- 展示查看卡片 -->
            <ViewCard :info="viewCardInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showReceiveCard">
            <!-- 展示收到卡片 -->
            <ReceiveCard :info="receiveCardInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showReceiveCardError">
            <!-- 展示收到卡片出错 -->
            <ReceiveCardError :info="receiveCardErrorInfo" @emitEvent="receiveEvent" />
        </template>

    </div>
</template>

<script>

import { Card, ViewCard, ReceiveCard, ReceiveCardError } from './components'

export default {

    name: 'CardArea',

    components: {

        Card,

        ViewCard,

        ReceiveCard,

        ReceiveCardError,

    },

    props: {

        info: { // 集卡区域页面配置
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        receiveData: { // 接收数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

    },

    inject: ['$$activityStatus', '$$activityType', '$$activityId'],

    computed: {
        $activityStatus() {
            return this.$$activityStatus()
        },
    },

    watch: {

        pageDetail: {
            handler(val) {
                if (val) {
                    this.showCardList = false
                    this.$nextTick(() => {
                        this.initCardList()
                    })
                }
            },
            deep: true
        },

        receiveData: { // 接收数据
            handler(val) {
                this.dispatchEvent(val)
            },
            deep: true,
        }

    },

    data() {

        return {

            areaStyle: {},                // 区域内样式

            cardList: [],                 // 卡片列表

            newCardList: [],                 // 卡片列表

            showCardList: false,          // 展示卡片列表

            showViewCard: false,          // 是否展示显示卡片

            viewCardInfo: {},              // 查看卡片信息

            showReceiveCard: false,        // 是否展示收到卡片

            receiveCardInfo: {},           // 收到卡片信息

            showReceiveCardError: false,   // 是否展示收到卡片错误

            receiveCardErrorInfo: {},      // 收到卡片错误信息

        }

    },

    mounted() {

        this.init()

        if (this.receiveData) {
            this.dispatchEvent(this.receiveData)
        }

    },
    methods: {

        async init() { // init 函数
            await this.initStyle()
            await this.initCardList()
        },

        initCardList() { // 初始化卡片列表
            let list = this.info.list  // 集卡次数 卡片配置 把不同部分的数据整合到一起

            let $list = this.pageDetail.cardList
            if ($list) {
                list.forEach((item) => {
                    $list.forEach(($item) => {
                        if (item && item.baseConfig && item.baseConfig.base && item.baseConfig.base.cardId) {
                            let cardColumnNo = item.baseConfig.base.columnNo
                            if ($item.column === cardColumnNo) {
                                item = Object.assign(item, {
                                    $$opts: $item,
                                })
                            }
                        }
                    })
                })
                this.showCardList = true
            }
            this.cardList = list
        },

        initStyle() { // 生成动态样式
            let val = this.info
            if (val.baseConfig) {
                let backHeight = window.screen.availWidth / (val.baseConfig.img.width / val.baseConfig.img.height)
                let height = {
                    height: `${backHeight}px`
                }
                let background = {}
                if (val && val.baseConfig && val.baseConfig.img && val.baseConfig.img.url) {
                    background = {
                        backgroundImage: `url(${val.baseConfig.img.url})`,
                        backgroundSize: `100% ${backHeight}px`,
                        backgroundPosition: '0px 0px',
                    }
                }

                this.areaStyle = {
                    ...height,
                    ...background
                }
            }
        },

        viewCard(data) { // 查看卡片
            let { index = 0 } = data
            this.viewCardInfo = this.cardList[index]
            this.shareViewCard(this.viewCardInfo.$$opts, null)
        },

        closeViewCard() { // 关闭查看卡片
            this.viewCardInfo = {}
            this.showViewCard = false
        },

        shareViewCard(data, options) { // 分享查看的卡片
            this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data: {
                    shareType: 'viewCard',
                    cardId: data.cardId
                },
                options: options
            })
        },

        receiveCardInit(data, options) { // 展示收到的卡片
            let status = this.$activityStatus
            if (status != 3) {
                return
            }
            let list = this.cardList
            list.forEach(item => {
                if (item.$$opts && item.$$opts.cardId == data.cardId) {
                    data = Object.assign(data, item)
                }
            })
            this.receiveCardInfo = data
            if (this.pageDetail.showCardReceive) {
                this.showReceiveCard = true
            }
        },

        closeReceiveCard() { // 关闭接收卡片
            this.showReceiveCard = false
            this.receiveCardInfo = {}
        },

        saveReceiveCard(data, options) { // 保存接收到的卡片
            this.$emit('emitEvent', {
                type: 'receiveCardEvent',
                data,
                options
            })
        },

        receiveCardResponse(res, options) { // 收到卡片响应
            if (res.success) {
                this.toast('领取成功')
            } else {
                let { errorCode } = res
                if (errorCode && ['CLA100101', 'CLA100102', 'CLA100103'].indexOf(errorCode) > -1) {
                    let errObj = {
                        CLA100101: 'other', CLA100102: 'expired', CLA100103: 'self'
                    }
                    let list = this.cardList
                    list.forEach(item => {
                        if (item.$$opts && item.$$opts.cardId == options.cardId) {
                            this.showReceiveCardError = true
                            this.receiveCardErrorInfo = {
                                errorType: errObj[errorCode],
                                receiveConfig: item.receiveConfig
                            }
                        }
                    })
                } else {
                    this.toast(res.errorMessage)
                }
            }
        },

        closeReceiveCardError() { // 关闭集卡错误
            this.showReceiveCardError = false
            this.receiveCardErrorInfo = {}
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },

        dispatchEvent(e) { // 分发来自父级的事件
            const {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this.$nextTick(() => {
                this[type] && this[type](data, options)
            })
        },

        receiveEvent(e) { // 接收子组件的事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        },

    },

}
</script>

<style lang="scss" scoped>
.card-area {
    width: 100%;
    position: relative;
}
</style>
